// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__24QxW","footer":"ModalFilter_footer__1GPsf"};